import React from "react";
import "../assets/css/about_style.css";
import "../assets/css/Responsive/about_responsive.css";

export default function Aboutus() {
  document.title = "Sanvicasa - About Us";

  return (
    <div>
      <div className="about-container">
        {/* section 1 */}
        {/* <div className="about-sec1" data-aos="fade-down">
          <div className="about-back">
            <h1>About Us</h1>
          </div>
        </div> */}
        <div className="about-hero">
          <div className="about-hero-content" data-aos="fade-down">
            <h1>About Us</h1>
            <p>
              We are committed to delivering quality real estate solutions with
              professionalism, transparency, and trust.
            </p>
          </div>
        </div>

        {/* <div className="about-details">
          <div className="inner" data-aos="fade-up" data-aos-delay="200">
            <h1 data-aos="fade-right" data-aos-delay="100">
              Space for Tranquility
            </h1>
            <p data-aos="fade-left" data-aos-delay="200">
              Discover the epitome of luxury living with our exclusive
              collection of homes designed for the golden lifestyle. Each
              property in our portfolio is meticulously crafted to embody
              elegance, sophistication, and unparalleled comfort. From
              breathtaking views to exquisite amenities, every detail has been
              curated to ensure an extraordinary living experience. Elevate your
              lifestyle and indulge in the opulence of our coveted residences.
              Welcome to a world where luxury knows no bounds.
            </p>
          </div>
        </div> */}
        <div className="about-details">
          <div className="inner" data-aos="fade-up" data-aos-delay="200">
            <h1 data-aos="fade-right" data-aos-delay="100">
              Meet Our Directors
            </h1>
          </div>

          {/* Directors Section */}
          <div className="directors-wrapper">
            <div className="director-card" data-aos="fade-up" data-aos-delay="100">
              <h3>Adit Patel</h3>
              <span>Director</span>
              <p>
                holds a Master’s degree from Texas A & M University, College Station.He leads the firm’s strategic planning and project execution, bringing strong expertise in construction management, innovation, and quality - driven operations.

              </p>
            </div>

            <div className="director-card" data-aos="fade-up" data-aos-delay="200">
              <h3>Yash Patel</h3>
              <span>Director</span>
              <p>
                earned his Master’s degree from the University of Florida.He oversees operations and process optimization, ensuring every project meets high standards of efficiency, safety, and timely delivery.
              </p>
            </div>

            <div className="director-card" data-aos="fade-up" data-aos-delay="300">
              <h3>Megh Patel</h3>
              <span>Director</span>
              <p>
                completed his Master’s degree from the University of Texas at Arlington.He directs engineering, design coordination, and technical development, focusing on precision, sustainability, and modern construction practices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}






